import { SkateboardingIcon } from './SkateboardingIcon';

/**
 * author: Google
 * id 47F1C290-ED78-4459-B33C-6E2ACC867CC6
 * name skateboarding
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skateboarding.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const HumanSkateboardingIcon = SkateboardingIcon;
export default HumanSkateboardingIcon